(function() {
    var container = document.getElementsByClassName("api-playground-headers")[0];
    var addRow = document.getElementsByClassName("api-playground-headers-add-row")[0];
    var removeRow = document.getElementsByClassName("api-playground-headers-remove-row")[0];
    var actions = document.getElementsByClassName("api-playground-headers-actions")[0];
    var row = document.getElementsByClassName("api-playground-headers-row")[0];
    var headersValue = document.getElementsByClassName("api-playground-headers-json")[0];
    var containerInputs = container.getElementsByTagName("input");

    function updateHeaders() {
        var headers = {};
        var rows = document.getElementsByClassName("api-playground-headers-row");
        for (var index = 0; index < rows.length; index++) {
            var key = rows[index].getElementsByClassName("api-playground-headers-key")[0].value;
            var value = rows[index].getElementsByClassName("api-playground-headers-value")[0].value;
            if (key.length > 0) {
                headers[key] = value;
            }
        }
        headersValue.value = JSON.stringify(headers);
        headersValue.dispatchEvent(new Event("change"));
    }

    setTimeout(function(){
        updateHeaders();
    }, 100);

    for (var index = 0; index < containerInputs.length; index++) {
        containerInputs[index].addEventListener("change", function(){
            if (this.getAttribute("type") != "hidden") {
                updateHeaders();
            }
        });
    }

    removeRow.addEventListener("click", function(){
        var rows = document.getElementsByClassName("api-playground-headers-row");
        if (rows.length > 1) {
            this.closest(".api-playground-headers-row").remove();
        }
        updateHeaders();
    })

    addRow.addEventListener("click", function(){
        var newRow = row.cloneNode(true);

        var newRowInputs = newRow.getElementsByTagName("input");
        for (var index = 0; index < newRowInputs.length; index++) {
            newRowInputs[index].value = "";
            newRowInputs[index].addEventListener("change", function(){
                if (this.getAttribute("type") != "hidden") {
                    updateHeaders();
                }
            });
        }

        var newRowRemoveRow = newRow.getElementsByClassName("api-playground-headers-remove-row")[0];
        newRowRemoveRow.addEventListener("click", function(){
            var rows = document.getElementsByClassName("api-playground-headers-row");
            if (rows.length > 1) {
                this.closest(".api-playground-headers-row").remove();
            }
            updateHeaders();
        })

        container.insertBefore(newRow, actions);
        updateHeaders();
    })
})(); 